<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M5.59 24a2 2 0 002.82 0l2.3-2.29a1 1 0 00-1.42-1.42L8 21.59V8h13.59l-1.3 1.29a1 1 0 000 1.42 1 1 0 001.42 0L24 8.41a2 2 0 000-2.82l-2.29-2.3a1 1 0 00-1.42 1.42L21.59 6H7a1 1 0 00-1 1v14.59l-1.29-1.3a1 1 0 00-1.42 1.42zM26 24v-3a1 1 0 00-2 0v3h-3a1 1 0 000 2h3a2 2 0 002-2zM24 11.25v1.5a1 1 0 002 0v-1.5a1 1 0 00-2 0zM26 16.25a1 1 0 00-2 0v1.5a1 1 0 002 0zM12.75 26a1 1 0 000-2h-1.5a1 1 0 000 2zM17.75 26a1 1 0 000-2h-1.5a1 1 0 000 2z"/></svg>